import React , {useEffect} from "react";
import "./PerformanceMetrics.scss";
import ontimeicon from "../../../../../../../Assets/AppComponent/Customersupport_icon/Openttimeicon.svg"
import reopenicon from "../../../../../../../Assets/AppComponent/Customersupport_icon/reopenrateicon.svg"
import {clearCustomPerformanceMatrixState} from  "../../../../../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";
export default function PerformanceMetrics({
 datas,
  PriorityValues,
  SttausValues,
  Client,
  range,
  date
}) {
  const dispatch = useDispatch()
  const state = useSelector((state)=>state)
const PerformanceMatri_datas = useSelector((state)=>state.CustomPerformanceMatrix.CustomPerformanceMatrixData)
let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");


      useEffect(()=>{
            if(state.ClientBranchIDs.SUBROLE == 3){

    const payload ={
    state:datas?.state,
    region:datas?.region,
    zone:datas?.zone,
     priority:PriorityValues,
     client:Client,
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
      date:date,

                }
    dispatch(clearCustomPerformanceMatrixState(payload))
              }
    },[datas  ,Client  ,PriorityValues ,range,date ])
console.log(PerformanceMatri_datas ,"PerformanceMatri_datas");


  return (
    <div className="performance-metrics">
       <div className="Matrix_headers">
        <h6>{"Performance Metrics"}</h6>
      </div>
      <div className="metrics-row">
        <div className="metric-card">
          <div className="icon orange">
            <img src={ontimeicon}/>
          </div>
              <div>
              <div className="label">On-Time Closure</div>
          <div className="value">
{(PerformanceMatri_datas?.ontime_closure_percentage ?? 0).toFixed(2)}%
          </div>
          </div>
        </div>
        <div className="metric-card">
          <div className="icon orange">
            <img src={reopenicon}/>
          </div>
          <div>
              <div className="label">Reopen Rate</div>
          <div className="value">
              {(PerformanceMatri_datas?.reopen_percentage ?? 0).toFixed(2)}%

          </div>
        </div>
        </div>
      </div>
    </div>
  );
}
